import { EmployeeService } from '../../services/employee.service';
import { assetUrl } from 'src/single-spa/asset-url';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { EmployeeState } from 'src/app/modules/store/employee/employee.reducer';
import * as fromEmployeeActions from './../../../store/employee/employee.actions';
import { Observable } from 'rxjs';
import * as fromEmployeeSelectors from '../../../store/employee/employee.selectors';
import { first } from 'rxjs/operators';
import { Department, EmployeeJobCode, IEmployee, ILanguage } from '@signal/asp-data-commons';
import { AlertService } from '../../services/alert.service';
import { SubscriptionList } from '../../../shared/models/asp.types';
import * as util from '../../../shared/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { phoneValidator } from '../../validators/custom-email-validator';
import { countryCd, countryPhoneNumber } from '../../../shared/services/util.service';


@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.scss']
})
export class EmployeeFormComponent implements OnInit, OnDestroy {
  employeeForm: UntypedFormGroup;
  @ViewChild('fileInput', { static: false }) el: ElementRef;
  nameInitials = '';
  imageUrl: any;
  uploadUrl: string;
  editFile = true;
  imageName = '';
  removeUpload = false;
  isLoading$: Observable<boolean>;
  employee$: Observable<IEmployee>;
  employee: IEmployee;
  activeAdvisors = 0;
  preferredCountries: string = this.translate.currentLang ? this.translate.currentLang.split('-')[1].toLowerCase(): 'us';
  languages: any[] = [
    {
      languageId: 'en',
      language: 'English'
      
    },
    {
      language: 'French',
      languageId: 'fr'
      
    }, {
      language: 'Japanese',
      languageId: 'ja'
      
    }, {
      language: 'Hindi',
      languageId: 'hi'
    }, {
      language: 'Chinese',
      languageId: 'zh'
    }, {
      language: 'Tagalog',
      languageId: 'tl'
      
    }, {
      language: 'Vietnamese',
      languageId: 'vi'
    }, {
      language: 'Arabic',
      languageId: 'ar'
    }, {
      language: 'Korean',
      languageId: 'ko'
    }, {
      language: 'Russian',
      languageId: 'ru'
    }, {
      language: 'German',
      languageId: 'de'
    }, {
      language: 'Haitian Creole',
      languageId: 'ht'
    },
    {
      language: 'Portuguese',
      languageId: 'pt'
    }, {
      language: 'Italian',
      languageId: 'it'
    }, {
      language: 'Polish',
      languageId: 'pl'
    },
    {
      language: 'Spanish',
      languageId: 'es'
    }
  ];
  skillList: string[] = ['A', 'B', 'C'];
  private subs: SubscriptionList = {};
  txmFlag: boolean = false;
  avatarImg : string = 'images/avatar.jpg';
  // @ViewChild('option') option: ElementRef;
  @ViewChild('form') form: ElementRef;
  clickedOutside=false;
  isEnglishText:boolean = true; 
  matcher = new util.DirtyErrorStateMatcher();
  countryCode = countryPhoneNumber(countryCd);
  
  constructor(public readonly dialogRef: MatDialogRef<EmployeeFormComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private readonly cd: ChangeDetectorRef,
    public readonly formBuilder: UntypedFormBuilder,
    private readonly employeeStore: Store<EmployeeState>,
    private readonly employeeService: EmployeeService,
    private translate: TranslateService,
    private alertService: AlertService) {

      if(this.translate.currentLang?.includes('es')){
        this.isEnglishText = false;
      }

    this.employeeForm = formBuilder.group({
      id: [''],
      firstName: [''],
      lastName: [''],
      dealerCode: [''],
      phone: ['', [phoneValidator]],
      languages: ['',[Validators.required]],
      email: ['', [Validators.required, Validators.pattern(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/)]],
      visibility: [''],
      avatar: [''],
      displayName: ['', [Validators.required]],
      flatRateHours: ['', [Validators.pattern(/^\d{0,2}(?:\.\d)?$/), Validators.min(0), Validators.max(100), Validators.required]],
      isActive: [''],
      isTxm: [false],
      skillLevel: [''],
      team: [''],
      newSales: [false],
      usedSales: [false],
      remoteConsultant: [false],
      testdrive: [false],
      learning: [false],
      delivery: [false],
      finance: [false]
    });
    this.txmFlag = util.globalTXM;
    this.isLoading$ = this.employeeStore.select(fromEmployeeSelectors.selectUpdateEmployeeLoading);
    this.employee$ = this.employeeStore.select(fromEmployeeSelectors.selectCurrentEmployee);
    this.subs.employee = this.employee$.pipe(first()).subscribe(_emp => {
      this.subs.empData = this.employee$.subscribe(empData => {
        if (empData?.id != null) {
          this.employee = empData;
          this.setupActiveAdvisorCountSubscription(empData.department);
          this.uploadUrl = empData.preSignedUrl;
          this.nameInitials = empData.firstName.charAt(0).toUpperCase() + empData.lastName.charAt(0).toUpperCase();
          this.imageUrl = empData.avatar && empData.avatar !== '' ? `${empData.avatar}?date=${new Date().getTime()}` : assetUrl(this.avatarImg);
          this.employeeForm.patchValue(empData);
          if (empData.phone && !empData.phone?.includes('+')) {
            this.employeeForm.controls['phone'].patchValue(`${this.countryCode}${empData.phone}`);
          }
          const phoneControl = this.employeeForm.get('phone');
          if (phoneControl?.invalid) {
            phoneControl.markAsTouched();
            phoneControl.markAsDirty();
          }
          if (empData.jobCode === EmployeeJobCode.ADVISOR) {
            this.employeeForm.get('flatRateHours').clearValidators();
            this.employeeForm.get('flatRateHours').updateValueAndValidity();
          }
          if (empData.jobCode === EmployeeJobCode.TECHNICIAN) {
            this.employeeForm.get('languages').clearValidators();
            this.employeeForm.get('languages').updateValueAndValidity();
          }
          this.employeeForm.updateValueAndValidity();
        }
      });
    });
  }

  get f() {
    return this.employeeForm.controls;
  }

  @HostListener("document:click", ['$event.target'])
  showMessage(event)
  {    
    if (!this.form.nativeElement.contains(event) )
    {
      if( this.data.clicked) {
          this.data.clicked=false;
      }
      else{
          this.clickedOutside=true;
      }
    }
  }

  ngOnInit() {
    // this.languages = this.languages.sort(this.sortLanguage);
    // this.languages = this.options.languages.slice();
    this.languages?.sort((a, b) => a.language.localeCompare(b.language));
  }
  // sortLanguage(a, b) {
  //   if (a.language < b.language) {
  //     return -1;
  //   }
  //   if (a.language > b.language) {
  //     return 1;
  //   }
  //   return 0;
  // }

  uploadFile(event) {
    const reader = new FileReader(); // HTML5 FileReader API
    const file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      if (!this.validateFile(file.name)) {
        this.alertService.showAlert(this.translate.instant('otherTexts.selectedFileFormatIsNotSupported'));
        return false;
      }
      reader.readAsDataURL(file);
      this.imageName = event.target.files[0].name;
      // When file uploads set it to file formcontrol
      reader.onload = () => {
        this.imageUrl = reader.result;
        this.employeeForm.get('avatar').patchValue(reader.result);

        this.editFile = false;
        this.removeUpload = true;
        this.employeeStore.dispatch(new fromEmployeeActions.LoadPreSignedUrl({ empId: this.employee.id, imageFormat: event.target.files[0].type.split('/')[1] }));
      };
      // ChangeDetectorRef since file is loading outside the zone
      this.cd.markForCheck();
    }
  }

  close() {
    this.dialogRef.close();
    this.clickedOutside=false;
  }

  clear() {
    this.employeeForm.get('phone').patchValue('');
    this.employeeForm.get('languages').patchValue('');
    this.employeeForm.get('email').patchValue('');
    this.employeeForm.get('visibility').patchValue('');
    this.employeeForm.get('avatar').patchValue('');
    this.employeeForm.get('team').patchValue('');
    this.employeeForm.get('skillLevel').patchValue('');
    this.employeeForm.get('flatRateHours').patchValue('');
    this.imageName = '';
    this.imageUrl = assetUrl(this.avatarImg);
  }

  save() {
    if (this.employeeForm.valid) {
      if (this.el && this.el.nativeElement.files[0] && this.validateFile(this.el.nativeElement.files[0].name)) {
        this.subs.preSignedUrl = this.employeeStore.select(fromEmployeeSelectors.selectPreSignedUrl).subscribe(preSignedUrl => {
          this.uploadUrl = preSignedUrl;
          const imgUrl = this.employeeService.buildImageUrl(this.f.dealerCode.value, this.f.id.value, this.el.nativeElement.files[0]);
          this.imageUrl = imgUrl + `?date=${new Date().toISOString()}`;
          this.employeeForm.get('avatar').patchValue(imgUrl);
          this.employeeService.uploadEmployeeImage(preSignedUrl, this.el.nativeElement.files[0]).subscribe(
            val => {
                return val;
            },
            () => {},
            () => {
                this.dispatchActions();
            }
        );
        })
      } else {
        this.dispatchActions();
      }
      this.dialogRef.close();
    } else {
      this.employeeForm.markAllAsTouched();
      this.employeeForm.updateValueAndValidity();
    }
  }

  isSaveDisabled(): boolean {
    return !this.employeeForm?.valid || this.employeeForm?.pending;
  }

  private dispatchActions() {
    const employeeFormData = { ...this.employee };
    delete (employeeFormData.preSignedUrl);
    this.employeeStore.dispatch(new fromEmployeeActions.UpdateEmployee({ employee: { ...employeeFormData, ...this.employeeForm.value },
    isLoadNotificationData : this.shouldLoadNotificationData()}));
  }

  private setupActiveAdvisorCountSubscription(department: Department): void {
    if (this.subs.activeAdvisorCount) {
      this.subs.activeAdvisorCount.unsubscribe();
    }

    if (department === Department.SALES) {
      this.subs.activeAdvisorCount = this.employeeStore.select(fromEmployeeSelectors.selectActiveSalesAdvisorsCount)
        .subscribe(count => {
          this.activeAdvisors = count;
        });
      return;
    }

    if (department === Department.SERVICE) {
      this.subs.activeAdvisorCount = this.employeeStore.select(fromEmployeeSelectors.selectActiveAdvisorsCount)
        .subscribe(count => {
          this.activeAdvisors = count;
        });
      return;
    }

    if (department === Department.PARTS) {
      this.subs.activeAdvisorCount = this.employeeStore.select(fromEmployeeSelectors.selectActivePartsAdvisorsCount)
        .subscribe(count => {
          this.activeAdvisors = count;
        });
      return;
    }

    this.activeAdvisors = 0;
  }

  private shouldLoadNotificationData(): boolean {
    const isAdvisorDepartment = this.employee?.jobCode === EmployeeJobCode.ADVISOR
      && (this.employee?.department === Department.SERVICE
      || this.employee?.department === Department.SALES
      || this.employee?.department === Department.PARTS);
    return isAdvisorDepartment
      && ((this.activeAdvisors === 0 && this.employeeForm.value.isActive)
      || (this.activeAdvisors === 1 && !this.employeeForm.value.isActive));
  }

  getEmployeeDialogTitleKey(employee: IEmployee): string {
    if (employee?.jobCode !== EmployeeJobCode.ADVISOR) {
      return 'servicePersonnel.editServiceTechnician';
    }
    if (employee?.department === Department.SERVICE) {
      return 'servicePersonnel.editServiceAdvisor';
    }
    if (employee?.department === Department.PARTS) {
      return 'servicePersonnel.editPartsAdvisor';
    }
    return 'servicePersonnel.editSalesAdvisor';
  }

  deleteAvatar(event) {
    event.stopPropagation();
    this.imageUrl = assetUrl(this.avatarImg);
    this.employeeForm.get('avatar').patchValue('');
  }

  languageCompareWith = (l1: ILanguage, l2: ILanguage) => {
    return l1.languageId === l2.languageId;
  }
  updateSwitchValues(event:boolean, property: string) {
    switch (property) {
      case 'isActive':
        this.employeeForm.get('isActive').patchValue(event);
        break;
      case 'isTxm':
        this.employeeForm.get('isTxm').patchValue(event);
        break;
      case 'remoteConsultant':
        this.employeeForm.get('remoteConsultant').patchValue(event);
        break;
      case 'newSales':
        this.employeeForm.get('newSales').patchValue(event);
        break;
      case 'usedSales':
        this.employeeForm.get('usedSales').patchValue(event);
        break;
      case 'testdrive':
        this.employeeForm.get('testdrive').patchValue(event);
        break;
      case 'delivery':
        this.employeeForm.get('delivery').patchValue(event);
        break;
      case 'learning':
        this.employeeForm.get('learning').patchValue(event);
        break;
      case 'finance':
        this.employeeForm.get('finance').patchValue(event);
        break;
      default:
        break;
    }
  }
  validateFile(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'jpeg') {
      return true;
    }
    else {
      return false;
    }
  }
  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
  }

  getTranslation(language){
    return language ? this.translate.instant(`common.${language}`): language;
  }

}